import { colors } from '../../../../colorVars';
import CloseWindowButton from '../../buttons/closeWindow/CloseWindowButton'
import { Body2 } from '../../text/Text';
import style from './ModuleHeader.module.css';

type Props = {
  clickHandler: (value?: any) => any;
  title: string;
}

export const ModuleHeader = ({clickHandler, title}: Props) => {
  return (
    <header className={style.header}>
          <div className={style.group}>
            <Body2 margin="0 5px 0 0" color={colors.lightGrey} fontWeight={700}>
              {title}
            </Body2>
          </div> 

          <CloseWindowButton
            width={15}
            stroke={2}
            color={colors.red}
            handleClick={clickHandler}
          />
        </header>
  )
}